import React from 'react';
import { message, Input, Modal, Typography, Form, Button, Row, Col, Select } from 'antd';
import { IoPersonAddOutline } from 'react-icons/io5';
import { useCrearCliente, useClientes } from '../../../hooks/useClientes';

const { Text, Title } = Typography;

const ModalClienteRapido = ({ isModalClienteOpen, setClienteSeleccionado, setIsModalClienteOpen }) => {

    const [formCliente] = Form.useForm();
    const { mutate: crearClienteRapido, isPending: creandoCliente } = useCrearCliente();

    const { data: clientesDB = [] } = useClientes();
    const clientes = Array.isArray(clientesDB) ? clientesDB : [];

    const handleCrearClienteRapido = (values) => {
        const payload = {
            ...values,
            status_credito: 'activo'
        };

        crearClienteRapido(payload, {
            onSuccess: (respuestaLambda) => {
                const idNuevo = respuestaLambda.id || respuestaLambda.data?.id || respuestaLambda;
                setClienteSeleccionado({ id: idNuevo, lista_precio_id: null });

                setIsModalClienteOpen(false);
                formCliente.resetFields();
                message.success(`Cliente ${values.nombre} creado y seleccionado.`);
            },
            onError: (err) => {
                message.error("Error al crear cliente: " + (err.response?.data?.error || err.message));
            }
        });
    };

    return (
        <Modal
            title={null}
            open={isModalClienteOpen}
            onCancel={() => { setIsModalClienteOpen(false); formCliente.resetFields(); }}
            footer={null}
            centered
            width={480}
            zIndex={1050}
            styles={{ mask: { background: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(5px)' } }}
        >
            <div style={{ textAlign: 'center', padding: '15px 0 25px' }}>
                <div style={{ background: '#f0f9ff', width: '55px', height: '55px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                    <IoPersonAddOutline style={{ fontSize: '26px', color: '#0284c7' }} />
                </div>
                <Title level={4} style={{ margin: 0, fontSize: '20px' }}>Nuevo Cliente</Title>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Text type="secondary" style={{ marginTop: '8px' }}>Registra los datos básicos para asociarle la deuda. Podrás completar más detalles después en el Módulo de Clientes.</Text>
                </div>
            </div>

            <Form form={formCliente} layout="vertical" onFinish={handleCrearClienteRapido}>
                <Form.Item
                    name="nombre"
                    label={<Text strong style={{ fontSize: '13px' }}>Nombre Completo o Razón Social</Text>}
                    rules={[{ required: true, message: 'El nombre es obligatorio' }]}
                >
                    <Input placeholder="Ej. Juan Pérez" size="large" style={{ borderRadius: '8px', height: '45px' }} autoFocus />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="documento"
                            label={<Text strong style={{ fontSize: '13px' }}>NIT / CC</Text>}
                            rules={[
                                { required: true, message: 'Obligatorio para fiar' },
                                () => ({
                                    validator(_, value) {
                                        if (!value) return Promise.resolve();
                                        const existe = clientes.some(c => String(c.documento).trim() === String(value).trim());
                                        if (existe) {
                                            return Promise.reject(new Error('Esta cédula/NIT ya está registrada.'));
                                        }
                                        return Promise.resolve();
                                    }
                                })
                            ]}
                            extra={<span style={{ fontSize: '11px', color: '#ef4444' }}>* Vital para cobros futuros.</span>}
                        >
                            <Input placeholder="Ej. 10203040" size="large" style={{ borderRadius: '8px', height: '45px' }} inputMode="numeric" pattern="[0-9]*" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="telefono"
                            label={<Text strong style={{ fontSize: '13px' }}>Teléfono (WhatsApp)</Text>}
                            rules={[
                                () => ({
                                    validator(_, value) {
                                        if (!value) return Promise.resolve();
                                        const existe = clientes.some(c => String(c.telefono).trim() === String(value).trim());
                                        if (existe) {
                                            return Promise.reject(new Error('Este teléfono ya está registrado.'));
                                        }
                                        return Promise.resolve();
                                    }
                                })
                            ]}
                        >
                            <Input placeholder="Ej. 300 123 4567" size="large" style={{ borderRadius: '8px', height: '45px' }} inputMode="tel" />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    name="lista_precio_id"
                    label={<Text strong style={{ fontSize: '13px' }}>Asignar Lista de Precios (Opcional)</Text>}
                >
                    <Select
                        placeholder="Precio Normal por defecto"
                        size="large"
                        allowClear
                        style={{ borderRadius: '8px', height: '45px' }}
                        options={[
                            { value: 'mayorista', label: 'Precio Mayorista' },
                            { value: 'distribuidor', label: 'Precio Distribuidor' },
                            { value: 'vip', label: 'Cliente VIP' }
                        ]}
                    />
                </Form.Item>

                <Button
                    type="primary"
                    htmlType="submit"
                    block
                    size="large"
                    loading={creandoCliente}
                    disabled={creandoCliente}
                    style={{ background: '#22BABB', height: '50px', borderRadius: '12px', fontWeight: 'bold', marginTop: '10px', fontSize: '15px', border: 'none' }}
                >
                    GUARDAR Y SELECCIONAR
                </Button>
            </Form>
        </Modal>
    )
}

export default ModalClienteRapido;